import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=21ecd2e2&scoped=true&"
import script from "./mail.vue?vue&type=script&lang=js&"
export * from "./mail.vue?vue&type=script&lang=js&"
import style0 from "./mail.vue?vue&type=style&index=0&id=21ecd2e2&prod&lang=less&scoped=true&"
import style1 from "./mail.vue?vue&type=style&index=1&id=21ecd2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ecd2e2",
  null
  
)

export default component.exports